export const OPM_PD_BASE_PATH = '/opm-pd';

export const POLICY_TRANSFER_REQUEST_PATH = '/policy-transfer-request';
export const REQUEST_APPROVAL_TO_LINE_MANAGER_PATH = '/request-approval-to-line-manager';
export const REPORT_FOR_ADMIN_PATH = '/report-for-admin';

export const OPM_PD_TITLE = 'opm_pd.pdPolicyReassignment';
export const POLICY_TRANSFER_REQUEST_TITLE = 'opm_pd.policyTransferRequest';
export const REQUEST_APPROVAL_TO_LINE_MANAGER_TITLE = 'opm_pd.requestApprovalToLineManager';
export const REPORT_FOR_ADMIN_TITLE = 'opm_pd.reportForAdmin';

export const OPM_PD_POLICY_TRANSFER_REQUEST_NAMESPACE = 'OPM-PD-POLICY-TRANSFER-REQUEST';
export const OPM_PD_LM_APPROVAL_NAMESPACE = 'OPM-PD-LM-APPROVAL';
export const OPM_PD_ADMIN_REPORT_NAMESPACE = 'OPM-PD-ADMIN-REPORT';

export enum AdminOpmPdPermissionType {
  OPM_PD_POLICY_TRANSFER_REQUEST_READ = 'READ_ANY_OPM-PD-POLICY-TRANSFER-REQUEST',
  OPM_PD_POLICY_TRANSFER_REQUEST_CREATE = 'CREATE_ANY_OPM-PD-POLICY-TRANSFER-REQUEST',
  OPM_PD_POLICY_TRANSFER_REQUEST_UPDATE = 'UPDATE_ANY_OPM-PD-POLICY-TRANSFER-REQUEST',

  OPM_PD_LM_APPROVAL_READ = 'READ_ANY_OPM-PD-LM-APPROVAL',
  OPM_PD_LM_APPROVAL_CREATE = 'CREATE_ANY_OPM-PD-LM-APPROVAL',
  OPM_PD_LM_APPROVAL_UPDATE = 'UPDATE_ANY_OPM-PD-LM-APPROVAL',

  OPM_PD_ADMIN_REPORT_READ = 'READ_ANY_OPM-PD-ADMIN-REPORT',
  OPM_PD_ADMIN_REPORT_CREATE = 'CREATE_ANY_OPM-PD-ADMIN-REPORT',
  OPM_PD_ADMIN_REPORT_UPDATE = 'UPDATE_ANY_OPM-PD-ADMIN-REPORT',
}
